import React, { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Sidebar } from "../components/dashboard/Sidebar";
import MembershipComponent from "./Membership/MembershipComponent";
// import HomePage from "../components/dashboard/HomePage";
// import { PlaceholderReport } from "../components/dashboard/PlaceHolderReport";
import { useAuth } from "../context";
import SalesComponent from "./Sales/SalesComponent";
import StocksComponent from "./Stocks/StocksComponent";
import FinancialComponent from "./Financial/FinancialComponent";
// import SalesComponent from "./Sales/SalesComponent";
// import StocksComponent from "./Stocks/StocksComponent";

const TITLES = {
  home: { title: "Home", subtitle: "Welcome to SBA Online" },
  overview: {
    title: "Overview",
    subtitle: "",
  },
  "membership-types": {
    title: "Membership Types",
    subtitle: "Life, Family, Corporate and more",
  },
  demographics: {
    title: "Demographics",
    subtitle: "Gender, age and audience composition",
  },
  retention: {
    title: "Active vs Inactive",
    subtitle: "Membership engagement and retention",
  },
  subscriptions: {
    title: "Subscriptions",
    subtitle: "Paid, unpaid and collection rate",
  },
  revenue: {
    title: "Revenue & Spend",
    subtitle: "Total revenue, ARPU and avg spend",
  },
  members: {
    title: "Members Directory",
    subtitle: "Detailed roster with filters",
  },
  // sales: { title: "Sales", subtitle: "Orders, transactions and revenue" },
  // "category-types": {
  //   title: "Sales By Category",
  //   subtitle: "Sales By Category",
  // },
  "sales-overview": {
    title: "Sales · Overview",
    subtitle: "MoM revenue, orders, basket size & payment mix",
  },
  "sales-record": {
    title: "Sales · View Entries",
    subtitle: "View Sales Entries",
  },
  "sales-by-store": {
    title: "Sales · By Store",
    subtitle: "Outlet contribution and monthly trend",
  },
  "sales-by-category": {
    title: "Sales · By Stock Category",
    subtitle: "Category mix and monthly trend",
  },
  "sales-by-agent": {
    title: "Sales · Agent's Report",
    subtitle: "Leaderboard, target attainment, avg basket",
  },
  "sales-top-products": {
    title: "Sales · Top Products",
    subtitle: "Best sellers by revenue and units",
  },
  "sales-hourly": {
    title: "Sales · Hourly / Daily Trend",
    subtitle: "Peak hours and day-of-week patterns",
  },
  "sales-payments": {
    title: "Sales · Payment Methods",
    subtitle: "Cash, M-Pesa, card and credit mix",
  },

  // stocks: { title: "Stocks", subtitle: "Inventory levels and SKUs" },
  "stocks-overview": {
    title: "Stocks · Overview",
    subtitle: "Closing value, turnover, reorder and category mix",
  },
  "stocks-balance": {
    title: "Stocks · Item Balance",
    subtitle: "On-hand quantities, cost and value per SKU",
  },
  "stocks-movement": {
    title: "Stocks · Movement",
    subtitle: "Purchases, transfers, sales and returns",
  },
  "stocks-adjustment": {
    title: "Stocks · Adjustment",
    subtitle: "Damage, expiry, theft and variance",
  },
  "stocks-consumption": {
    title: "Stocks · Consumption",
    subtitle: "Category and item-level issues",
  },
  "stocks-reorder": {
    title: "Stocks · Reorder Alerts",
    subtitle: "Items at or below reorder level",
  },
  "stocks-valuation": {
    title: "Stocks · Valuation",
    subtitle: "Opening → closing value bridge",
  },
  "stocks-closing": {
    title: "Stocks · Closing Entries",
    subtitle: "View Store-Stock Closing entries",
  },
  // financial reports
  "income-statement": {
    title: "Financial Position",
    subtitle: "Income Statement",
  },
};

function Dashboard({ children }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [report, setReport] = useState("overview");
  const [module, setModule] = useState("membership");
  const [collapsed, setCollapsed] = useState(false);

  const meta = TITLES[report];

  // ✅ User data from auth
  const fullName = user?.full_name || "N/A";
  const firstName = fullName !== "N/A" ? fullName.split(" ")[0] : "N/A";
  const displayEmail = user?.email || "N/A";
  const initials =
    fullName !== "N/A"
      ? fullName
          .split(" ")
          .map((w) => w[0])
          .join("")
          .slice(0, 2)
          .toUpperCase()
      : "NA";

  // ✅ Handle logout
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <div className="pbi-shell">
      <Sidebar
        active={report}
        onSelect={setReport}
        onSelectModule={setModule}
        collapsed={collapsed}
      />

      <main className="pbi-main">
        <header className="pbi-topbar">
          <div className="d-flex align-items-center gap-3">
            <Button
              variant="light"
              size="sm"
              className="pbi-collapse-btn"
              onClick={() => setCollapsed((c) => !c)}
            >
              <i
                className={`bi ${collapsed ? "bi-layout-sidebar-inset" : "bi-layout-sidebar"}`}
              />
            </Button>
            <div>
              <div className="pbi-page-title">{meta.title}</div>
              <div className="pbi-page-sub">{meta.subtitle}</div>
            </div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="pbi-pill">
              <i className="bi bi-circle-fill text-success small me-1" /> Live
            </div>

            {/* ✅ User Dropdown with Logout */}
            <Dropdown align="end">
              <Dropdown.Toggle
                as="div"
                className="pbi-user"
                style={{ cursor: "pointer" }}
              >
                <div className="pbi-avatar">{initials}</div>
                <div className="d-none d-md-block">
                  <div className="pbi-user-name">{firstName}</div>
                  <div className="pbi-user-role">Analytics</div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <div
                  style={{
                    padding: "12px 16px",
                    borderBottom: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: 700,
                      color: "#1a1e2b",
                    }}
                  >
                    {fullName}
                  </div>
                  <div style={{ fontSize: "11px", color: "#64748b" }}>
                    {displayEmail}
                  </div>
                </div>
                <Dropdown.Item
                  onClick={handleLogout}
                  style={{ color: "#dc2626" }}
                >
                  <i className="bi bi-box-arrow-right" /> Sign out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </header>

        {children ? (
          children
        ) : module === "membership" ? (
          <MembershipComponent report={report} />
        ) : module === "sales" ? (
          <SalesComponent report={report} />
        ) : module === "stocks" ? (
          <StocksComponent report={report} />
        ) : module === "financial" ? (
          <FinancialComponent report={report} />
        ) : (
          // <HomePage />
          <p>Select Report</p>
        )}
      </main>
    </div>
  );
}

export default Dashboard;
